var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conditions-page"},[_c('conditions',{attrs:{"showBtn":false,"showCloseBtn":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }